import ClipboardJS from "clipboard";
import {Message} from "element-ui";
export const copyText = (selector) => {
  const cli = new ClipboardJS(selector);
  cli.on("success", () => {
    Message.success("复制成功")
    cli.destroy();
  })

  cli.on("error", () => {
    Message.error("复制失败");
    cli.destroy();
  })
}
